import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.content-templates')
  .service('ContentTemplatesAPI', ContentTemplatesAPI);

function ContentTemplatesAPI(): BringozApi {
  return {
    base: `/contentTemplate`,
    infiniteScroll: {
      address: `/contentTemplate`,
      cmd: 'GET'
    },
    actions: {
      getExternalTemplate: {
        address: 'externalTemplates/{externalTemplateId}',
        cmd: 'GET',
      },
      createContentTemplate: {
        address: '',
        cmd: 'PUT',
      },
      editContentTemplate: {
        address: '{contentTemplateId}',
        cmd: 'POST',
      },
      deleteContentTemplate: {
        address: '{contentTemplateId}',
        cmd: 'DELETE',
      }
    }
  }
}
